"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceTypeBadgeAlt = class UcInvoiceTypeBadgeAlt extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    type;
    onType(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("type");
    }
    kind;
    onKind(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("kind");
    }
    messages;
    icons;
    ux;
    dataMembers = ['messages', 'icons', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    abbreviated: {
                        normal: this.$fn.pgettext("InvoiceType|Abbrev", "N"),
                        storno: this.$fn.pgettext("InvoiceType|Abbrev", "S"),
                        correction: this.$fn.pgettext("InvoiceType|Abbrev", "C"),
                        proforma: this.$fn.pgettext("InvoiceType|Abbrev", "PF"),
                    },
                    normal: this.$fn.pgettext("InvoiceType", "Normal"),
                    storno: this.$fn.pgettext("InvoiceType", "Storno"),
                    correction: this.$fn.pgettext("InvoiceType", "Correction"),
                    proforma: this.$fn.pgettext("InvoiceType", "Pro Forma"),
                },
                icons: {
                    incoming: "mdi:invoice-receive",
                    outgoing: "mdi:invoice",
                },
                ux: null,
            },
        };
    }
    get colorCodes() {
        if (this.loaded) {
            return this.$config.invoice.types.colorCodes[this.value];
        }
        return null;
    }
    get invoiceKindIcon() {
        if (this.loaded) {
            return this.icons[this.kind];
        }
        return null;
    }
    actions;
    getActions() {
        return {};
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceTypeBadgeAlt.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('type'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceTypeBadgeAlt.prototype, "onType", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceTypeBadgeAlt.prototype, "kind", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('kind'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceTypeBadgeAlt.prototype, "onKind", null);
UcInvoiceTypeBadgeAlt = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceTypeBadgeAlt);
exports.default = UcInvoiceTypeBadgeAlt;
vue_property_decorator_1.Vue.component("UcInvoiceTypeBadgeAlt", UcInvoiceTypeBadgeAlt);
